<!-- TOP THREE EVENTS SORTED BY totalActiveReservationsCount -->
<div class="row">
    <div class="col-lg-4">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title class="mingheightCardTitle">Top 1) {{top1Event?.title | truncate : 60: false}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="this.top1Event?.totalActiveReservationsCount != 0">
                    <ibm-donut-chart [data]="data_donut_1" [options]="config_donut"></ibm-donut-chart>
                    <div *ngIf="LoadingFlopsAndTops" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                <div *ngIf="this.top1Event?.totalActiveReservationsCount == 0" class="pieChartEmptyState">
                    Für diese Aktion sind noch keine Reservierungen vorhanden.
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-lg-4">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title class="mingheightCardTitle">Top 2) {{top2Event?.title| truncate : 60: false}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="this.top2Event?.totalActiveReservationsCount != 0">
                    <ibm-donut-chart [data]="data_donut_2" [options]="config_donut"></ibm-donut-chart>
                    <div *ngIf="LoadingFlopsAndTops" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                <div *ngIf="this.top2Event?.totalActiveReservationsCount == 0" class="pieChartEmptyState">
                    Für diese Aktion sind noch keine Reservierungen vorhanden.
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-lg-4">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title class="mingheightCardTitle"> Top 3) {{top3Event?.title| truncate : 60: false}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="this.top3Event?.totalActiveReservationsCount != 0">
                    <ibm-donut-chart [data]="data_donut_3" [options]="config_donut"></ibm-donut-chart>
                    <div *ngIf="LoadingFlopsAndTops" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                <div *ngIf="this.top3Event?.totalActiveReservationsCount == 0" class="pieChartEmptyState">
                    Für diese Aktion sind noch keine Reservierungen vorhanden.
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<!-- FLOP THREE EVENTS SORTED BY totalActiveReservationsCount -->
<div class="row">
    <div class="col-lg-4">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title class="mingheightCardTitle">Flop 1) {{flop1Event?.title | truncate : 60: false}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="this.flop1Event?.totalActiveReservationsCount != 0">
                    <ibm-donut-chart [data]="data_donut_1_flop" [options]="config_donut"></ibm-donut-chart>
                    <div *ngIf="LoadingFlopsAndTops" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                <div *ngIf="this.flop1Event?.totalActiveReservationsCount == 0" class="pieChartEmptyState">
                    Für diese Aktion sind noch keine Reservierungen vorhanden.
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-lg-4">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title class="mingheightCardTitle">Flop 2) {{flop2Event?.title| truncate : 60: false}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="this.flop2Event?.totalActiveReservationsCount != 0">
                    <ibm-donut-chart [data]="data_donut_2_flop" [options]="config_donut"></ibm-donut-chart>
                </div>
                <div *ngIf="this.flop2Event?.totalActiveReservationsCount == 0" class="pieChartEmptyState">
                    Für diese Aktion sind noch keine Reservierungen vorhanden.
                </div>
                <div *ngIf="LoadingFlopsAndTops" class="loadingOverlay">
                    <mat-spinner></mat-spinner>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-lg-4">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title class="mingheightCardTitle">Flop 3) {{flop3Event?.title| truncate : 60: false}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="this.flop3Event?.totalActiveReservationsCount != 0">
                    <ibm-donut-chart [data]="data_donut_3_flop" [options]="config_donut"></ibm-donut-chart>
                </div>
                <div *ngIf="this.flop3Event?.totalActiveReservationsCount == 0" class="pieChartEmptyState">
                    Für diese Aktion sind noch keine Reservierungen vorhanden.
                </div>
                <div *ngIf="LoadingFlopsAndTops" class="loadingOverlay">
                    <mat-spinner></mat-spinner>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>